"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ManageIp {
    static getAttributeTypeMap() {
        return ManageIp.attributeTypeMap;
    }
}
ManageIp.discriminator = undefined;
ManageIp.attributeTypeMap = [
    {
        "name": "ip",
        "baseName": "ip",
        "type": "string"
    }
];
exports.ManageIp = ManageIp;
//# sourceMappingURL=manageIp.js.map